/* eslint-disable @typescript-eslint/no-explicit-any */
import { useRetailerSearch } from "../react-hook/use-retailer-search";
import { Popover, PopoverContent } from "@/components/ui/popover";
import { cn } from "@/lib/utils";
import { PopoverTrigger } from "@radix-ui/react-popover";

export const ServerSelect = ({ retailerList, onSelect, list }: any) => {
  const { searchQuery, setSearchQuery, open, setOpen } = useRetailerSearch();
  console.log({ retailerList });
  return (
    <div>
      <Popover open={true}>
        <PopoverTrigger className="relative">
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search Item..."
            className="w-full md:w-80 border rounded-md py-2 px-3 pr-10"
            onClick={() => setOpen(true)}
            onBlur={() => {
              setTimeout(() => setOpen(false), 300);
            }}
          />
        </PopoverTrigger>
        <PopoverContent
          className={cn(
            "w-80 p-0 max-h-[300px] overflow-y-auto",
            open ? "" : "hidden"
          )}
          align="start"
        >
          <div className="grid">
            {retailerList?.filter((result: any) => {
              const name = result?.retailer_name?.toLowerCase() || "";
              const query = searchQuery.toLowerCase();
              return name.includes(query) && !list.includes(result.retailer_id);
            }).length === 0 ? (
              <div className="text-sm text-gray-500 px-4 py-3">
                No retailers found
              </div>
            ) : (
              retailerList
                ?.filter((result: any) => {
                  const name = result?.retailer_name?.toLowerCase() || "";
                  const query = searchQuery.toLowerCase();
                  return (
                    name.includes(query) && !list.includes(result.retailer_id)
                  );
                })
                .map((result: any) => (
                  <button
                    key={result.id}
                    className="w-full text-left text-sm px-4 py-3 hover:bg-gray-100 border-b last:border-b-0"
                    onClick={() => {
                      onSelect(result);
                      setSearchQuery("");
                      setOpen(false);
                    }}
                  >
                    {result.retailer_name}
                  </button>
                ))
            )}
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
};
